var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "globalsearchHeader",
      class: [
        "nav",
        "search",
        _vm.showSearch ? "is-open" : "",
        _vm.showResults ? "is-result-list-visible" : ""
      ],
      attrs: { "data-testid": "globalsearchHeader" }
    },
    [
      _c("div", { staticClass: "search__forms" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showSearch,
                expression: "showSearch"
              }
            ],
            staticClass: "search__form",
            attrs: { "data-testid": "globalsearch-form" }
          },
          [
            _c(
              "div",
              { staticClass: "search__form-options" },
              [
                _c("VueGlobalSearchCategoryList", {
                  directives: [
                    {
                      name: "log",
                      rawName: "v-log",
                      value: {
                        target: "Global Search Select Area",
                        event: "change"
                      },
                      expression:
                        "{\n\t\t\t\t\t\ttarget: 'Global Search Select Area',\n\t\t\t\t\t\tevent: 'change'\n\t\t\t\t\t}"
                    }
                  ],
                  attrs: {
                    options: _vm.areas,
                    "data-testid": "globalsearch-area-dropdown"
                  },
                  on: { change: _vm.handleAreaChange },
                  model: {
                    value: _vm.selectedArea,
                    callback: function($$v) {
                      _vm.selectedArea = $$v
                    },
                    expression: "selectedArea"
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "search__form-input-container" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchText,
                    expression: "searchText"
                  }
                ],
                ref: "globalsearchInput",
                staticClass: "search__form-input",
                attrs: {
                  "data-testid": "globalsearch-input",
                  type: "text",
                  placeholder: "Search..."
                },
                domProps: { value: _vm.searchText },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) return
                      _vm.searchText = $event.target.value
                    },
                    _vm.search
                  ],
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.navigateToUltimateSearch(_vm.selectedArea)
                  }
                }
              })
            ]),
            _c(
              "button",
              {
                staticClass: "search__form-btn",
                attrs: { "data-testid": "globalsearch-search-btn" },
                on: {
                  click: function($event) {
                    return _vm.navigateToUltimateSearch(_vm.selectedArea)
                  }
                }
              },
              [_c("i", { staticClass: "icon icon-search-2" })]
            )
          ]
        ),
        _c(
          "button",
          {
            staticClass: "search__btn",
            attrs: { "data-testid": "globalsearch-toggle-btn" },
            on: { click: _vm.toggleSearch }
          },
          [
            _c("span", { staticClass: "search__btn-icon-tablet-up" }, [
              _c("i", {
                class: [
                  "icon",
                  _vm.showSearch ? "icon-remove-2" : "icon-search-2"
                ]
              })
            ]),
            _vm._m(0)
          ]
        )
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showResults,
              expression: "showResults"
            }
          ],
          staticClass: "search__results",
          attrs: { "data-testid": "globalsearch-results" }
        },
        [
          _vm.loading
            ? _c("div", [_c("Loader", { attrs: { variant: "dots" } })], 1)
            : _vm._e(),
          _vm.hasResults
            ? _c(
                "div",
                { attrs: { "data-testid": "globalsearch-has-results" } },
                [
                  _c(
                    "ul",
                    { staticClass: "search__results-list" },
                    _vm._l(_vm.globalSearchResults.categories, function(
                      section
                    ) {
                      return _c(
                        "li",
                        {
                          key: section.areaName,
                          staticClass: "search__results-item"
                        },
                        [
                          _c("VueGlobalSearchSection", {
                            attrs: {
                              globalSearchSection: section,
                              ultimateSearchLink: _vm.ultimateSearchLink(
                                section.area
                              )
                            },
                            on: {
                              "globalsearch-clicked-result": _vm.hideSearch
                            }
                          }),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: section.totalCount > 3,
                                  expression: "section.totalCount > 3"
                                }
                              ],
                              staticClass: "search__link-see-more",
                              attrs: {
                                "data-testid": `globalsearch-result-see-more-${section.area}`,
                                target: "_blank",
                                href: _vm.ultimateSearchLink(section.area)
                              },
                              on: { click: _vm.hideSearch }
                            },
                            [
                              _vm._v(
                                "See more " + _vm._s(section.areaName) + "..."
                              )
                            ]
                          )
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]
              )
            : _vm._e(),
          !_vm.hasResults && !_vm.loading
            ? _c(
                "div",
                {
                  staticClass: "search__no-results",
                  attrs: { "data-testid": "globalsearch-no-results" }
                },
                [_c("span", [_vm._v(" No results found. ")])]
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "search__btn-icon-mobile" }, [
      _c("i", { staticClass: "icon icon-search-2" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }